import { SET_ERROR } from '../../actions/user';

export const error = (state = {}, action) => {
    switch(action.type) {
        case SET_ERROR:{
            return action.payload;
        }
        default:
            return state;
    }
}